<template>
    <div class="text-center">
        <RomaPdfViewer
                :pdfDoc="selectedPdf"
        />
        <RomaHorizontalPoll />
    </div>
</template>

<script>
    import RomaPdfViewer from "../components/commons/RomaPdfViewer";
    import RomaHorizontalPoll from "../components/mobile/RomaHorizontalPoll";

    export default {
        name: "Pdf",
        data() {
          return {
              closePdfViewer: false,
              showPdfViewer: true,
              selectedPdf: "https://dev.romaevalua.cl/pdf/18574",
          }
        },
        components: {
            RomaPdfViewer,
            RomaHorizontalPoll
        }
    }
</script>

<style scoped>

</style>
